import { styled } from '@linaria/react'
import { style } from '#styles'

export const PageLayout = styled.div`
  flex: 1;
  min-width: 1024px;
  display: flex;
  flex-direction: column;
  color: ${style.themeColors.textDefault};
    
  @media print {
    min-width: unset;
  }
`
